import {
  TPostInviteCurrentUserToDashboardGroup,
  TPostInviteToDashboardGroupPermission
} from 'redux/api/DashboardGroups/types'
import { AccountBody } from 'redux/reducers/Accounts'
import { TGroup } from 'types/GlobalGroup'
import {
  EAccountRole,
  TSignedInAccount,
  TAccount,
  TPermissionAccount
} from 'types/GlobalAccount'
import { formatUsername, isNewUserInvite } from 'utils/functions'

function formatAccount(
  account: TAccount,
  allowRevoke = false,
  owner = false
): TPermissionAccount {
  return {
    accountId: account.id,
    companyGroupId: account.company_group_id,
    name: formatUsername(account),
    email: account.email,
    role: account.role,
    allowRevoke,
    owner
  }
}

function getOwner(
  accounts: AccountBody,
  ownerId: string | null
): TPermissionAccount | null {
  if (!ownerId || !accounts[ownerId]) {
    return null
  }

  return formatAccount(accounts[ownerId], false, true)
}

export const getAccountPermissions = (
  accounts: TAccount[],
  accountBody: AccountBody,
  permissions: TPostInviteToDashboardGroupPermission[],
  signedInUser: TSignedInAccount | null,
  ownerId: string | null
): TPermissionAccount[] => {
  if (accountBody && signedInUser) {
    const owner = getOwner(accountBody, ownerId)

    const admins = accounts
      .filter(
        (account) =>
          account.role === EAccountRole.ADMIN && account.id !== ownerId
      )
      .map((account) => formatAccount(account))

    const viewers = permissions
      .filter(
        (
          permission
        ): permission is TPostInviteCurrentUserToDashboardGroup & {
          account_id: string
        } =>
          !isNewUserInvite(permission) &&
          !!permission.account_id &&
          !!accountBody[permission.account_id]
      )
      .map((permission) => {
        const account = accountBody[permission.account_id]

        return formatAccount(account, account.id !== signedInUser.id)
      })

    return [...(owner ? [owner] : []), ...admins, ...viewers]
  }

  return []
}

export function getGroupPermissions(
  groups: TGroup[],
  permissions: TPostInviteToDashboardGroupPermission[]
): TGroup[] {
  if (groups) {
    return permissions
      .filter(
        (
          permission
        ): permission is TPostInviteCurrentUserToDashboardGroup & {
          group_id: string
        } =>
          !isNewUserInvite(permission) &&
          !!permission.group_id &&
          !!groups.find((group) => group.id === permission.group_id)
      )
      .map(
        (permission) =>
          groups.find((group) => group.id === permission.group_id) as TGroup
      )
  }

  return []
}
